import { Controller } from "@hotwired/stimulus"

// Typeform-style step wizard for the single-generation form. Progressive
// disclosure: only the active step is shown, so the operator fills one phase
// at a time instead of facing every field at once.
//
// Every field stays in the DOM (hidden steps are display:none), so the form
// still submits all values in one POST and the other controllers on the page
// (industry-toggle, camera-suggest, pose-picker) keep working untouched. This
// is a pure presentation layer — no field is moved or removed.
//
// Degrades gracefully: with no JS the steps simply stack and the form works as
// one long scroll.
export default class extends Controller {
  static targets = ["step", "dot", "back", "next", "submit", "counter"]

  connect() {
    this.index = 0
    this.show()
  }

  next(e) {
    e?.preventDefault()
    if (this.index < this.stepTargets.length - 1) { this.index++; this.show() }
  }

  back(e) {
    e?.preventDefault()
    if (this.index > 0) { this.index--; this.show() }
  }

  goTo(e) {
    const i = parseInt(e.currentTarget.dataset.stepIndex, 10)
    if (!Number.isNaN(i)) { this.index = i; this.show() }
  }

  // Stop Enter in a text input from submitting the form before the last step.
  // Textareas (the prompt) keep their newlines; buttons/selects are untouched.
  keydown(e) {
    if (e.key !== "Enter") return
    const t = e.target
    if (t.tagName === "INPUT" && t.type !== "submit" && t.type !== "button" &&
        this.index < this.stepTargets.length - 1) {
      e.preventDefault()
    }
  }

  show() {
    const last = this.index === this.stepTargets.length - 1

    this.stepTargets.forEach((el, i) => {
      const active = i === this.index
      el.style.display = active ? "" : "none"
      if (active) {
        const scroller = el.querySelector(".tf-card") || el
        scroller.scrollTop = 0
      }
    })

    this.dotTargets.forEach((el, i) => {
      el.classList.toggle("is-active", i === this.index)
      el.classList.toggle("is-done", i < this.index)
    })

    if (this.hasBackTarget)    this.backTarget.hidden = this.index === 0
    if (this.hasNextTarget)    this.nextTarget.hidden = last
    if (this.hasSubmitTarget)  this.submitTarget.hidden = !last
    if (this.hasCounterTarget) this.counterTarget.textContent = `${this.index + 1} / ${this.stepTargets.length}`

    // Lets a sibling controller react to the phase change (e.g. a recap panel
    // that stays hidden on the first step). Nothing listens by default.
    this.dispatch("step", { detail: { index: this.index, total: this.stepTargets.length } })
  }
}
